module.exports = __webpack_public_path__ + "img/181122_AWS_TdoT_Plakat4.9c241579.jpg";